import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '~components/ui/select';
import type { ColourByParameter } from '~types';
import { PARAMETERS_LABEL_COLOURS } from '../config';

type OptimiserColourByParameterProps = {
  /** Currently selected colour by property, e.g., 'depth', 'diameter' */
  selectedColourByParameter: ColourByParameter;
  /** Callback when colour property changes */
  onColourByParameterChange: (property: ColourByParameter) => void;
};

/**
 * Dropdown selector for choosing a hole property to colour by
 */
const OptimiserColourByParameter = ({
  selectedColourByParameter,
  onColourByParameterChange,
}: OptimiserColourByParameterProps) => {
  return (
    <div className="space-y-4">
      <h3 className="font-bold text-foreground text-sm uppercase">Colour By</h3>
      <Select
        value={selectedColourByParameter}
        onValueChange={(value) => onColourByParameterChange(value as ColourByParameter)}
      >
        <SelectTrigger className="w-full text-sm">
          <SelectValue placeholder="Select a parameter" />
        </SelectTrigger>
        <SelectContent>
          {PARAMETERS_LABEL_COLOURS.map(({ label, value }) => (
            <SelectItem key={value} value={value}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export { OptimiserColourByParameter };
